import { Entity } from '@/store/shared/entity'
export default class FactoryEntity extends Entity<number>{
    factoryName:string;
    amount:number;
    currency:string;
    remark:string;
    declareCustomsId:number;
    factoryNameAndAmount:string;
}